
import { RefCodeTypeInfoBase } from './ref-code.typeinfo.base';


export class RefCodeTypeInfo extends RefCodeTypeInfoBase {
}

export const REF_CODE_TYPE: RefCodeTypeInfo = new RefCodeTypeInfo();



